module.exports = __webpack_public_path__ + "542f5b00561650549691a174dc18ee6e.svg";